module.exports = __webpack_public_path__ + "img/membro_comite.2b5f57bc.png";